/*
 * Copyright © 2018-2024, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import React from "react";
import { combineClassNames } from "../../util/HtmlUtils";

interface Props {
  children: React.ReactNode;
  hidden?: boolean;
  marginClass?: string;
  spaceYClass?: string;
  paddingClass?: string;
  style?: React.CSSProperties;
  title?: string;
}

export const SectionCard: React.FC<Props> = ({
  children,
  hidden = false,
  marginClass = "mt-0",
  paddingClass = "p-4",
  spaceYClass = "space-y-4",
  style,
  title,
}) => {
  return (
    <section
      hidden={hidden}
      className={combineClassNames("w-full md:tw-card", spaceYClass, paddingClass, marginClass)}
      style={style}
    >
      {title && (
        <h2 className="text-lg font-semibold leading-tight text-zinc-800 lg:text-xl dark:text-white flex">{title}</h2>
      )}
      {children}
    </section>
  );
};
